// NOTE: NSAI-5910 — the chat and notifications sockets refresh their token
// through the REST client's shared refresh (`ApiClient.refreshSession`), the
// way mobile already does. That joins a refresh already in flight instead of
// posting a second one (the route is rate limited per IP), and a refresh the
// server refuses signs the user out through the same flow as a REST 401 —
// before this the sockets posted /auth/refresh on their own and a refused
// refresh left the tab signed in with two dead sockets.
//
// The API client is registered here by `@/api/services` rather than imported:
// that module imports the chat socket to hand it REST refreshes, so a direct
// import back would be a cycle.
type TSessionRefresher = () => Promise<string>;

let sessionRefresher: TSessionRefresher | null = null;

export const registerSocketSessionRefresher = (
  refresher: TSessionRefresher,
): void => {
  sessionRefresher = refresher;
};

export const refreshSocketSession = async (): Promise<string | null> => {
  if (!sessionRefresher) {
    throw new Error("Socket session refresher is not registered");
  }

  const accessToken = await sessionRefresher();
  return accessToken || null;
};
